import {useEffect} from 'react';

const useDisableScroll = (isDisabled) => {
    useEffect(() => {
        const keys = {37: 1, 38: 1, 39: 1, 40: 1, 32: 1, 33: 1, 34: 1, 35: 1, 36: 1};

        function preventDefault(e) {
            if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
                return;
            }
            e.preventDefault();
        }

        function preventDefaultForScrollKeys(e) {
            if (keys[e.keyCode] && !(e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement)) {
                preventDefault(e);
                return false;
            }
        }

        var supportsPassive = false;
        try {
            window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
                get: function () {
                    supportsPassive = true;
                }
            }));
        } catch (e) {
        }

        var wheelOpt = supportsPassive ? {passive: false} : false;
        var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

        function disableScroll() {
            window.addEventListener('DOMMouseScroll', preventDefault, false);
            window.addEventListener(wheelEvent, preventDefault, wheelOpt);
            window.addEventListener('touchmove', preventDefault, wheelOpt);
            window.addEventListener('keydown', preventDefaultForScrollKeys, false);
        }

        function enableScroll() {
            window.removeEventListener('DOMMouseScroll', preventDefault, false);
            window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
            window.removeEventListener('touchmove', preventDefault, wheelOpt);
            window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
        }

        if (isDisabled) {
            disableScroll();
        } else {
            enableScroll();
        }

        return () => {
            enableScroll();
        };
    }, [isDisabled]);
};

export default useDisableScroll;
